export default {
  status: 0,
  data: {
    TBBA001: {
      CP_CD: '0801',
      CP_NM: 'KIOSK-BEVERAGE',
      CP_SHORT_NM: 'KIOSK-BEVERAGE',
      CP_EN_NM: '',
      CP_EN_SHORT_NM: '',
      BZ_NO: '0000000000',
      CORP_REG_NO: '',
      UPTAE_FLG_CD: '98',
      BOSS_NM: '',
      REP_TEL_NO: '',
      REP_FAX_NO: '',
      HMPG_ADDR: '',
      REP_EMAIL_ADDR: '',
      CNTRY_CD: '',
      ZIPNO: '',
      BASE_ADDR: '',
      DTL_ADDR: '',
      BASE_ADDR_EN: '',
      DTL_ADDR_EN: '',
      BANK_CD: '',
      BANK_ACC_NO: '',
      DPSTOR_NM: '',
      CI_FILE_ID: '',
      CP_PATH: 'Standard',
      CP_PORT: '9991',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-19 11:07:38',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-19 11:07:38',
      UPDTER_ID: '',
      UPDT_IP: '',
      DECIMAL_PLC: 0,
      AMT_UNIT: '1',
      SALE_UNIT: '1',
      AMT_CMPT_TYPE: '1',
      TAX_CMPT_TYPE: '1',
      TAX_RATE: 10,
      TAX_RDC_RATE: 0,
      CURR_UNIT: '001',
      TIME_ZONE: '230',
      CP_GLOBAL: 'Y',
      MST_USE_YN: 'Y',
      ERP_SEND_FLG: 'N',
      BO_URL: 'https://cloudposofficedevo.shinsegae.com',
      POS_MAIN_URL_CD: '001',
      POS_SUB_URL_CD: '001',
      POS_TRAIN_URL_CD: '001',
      VER_NO: '2',
      CLAS_LEVEL: '3',
      VAT_CMPT_TYPE: '2',
      NON_PLU_PREFIX: '20',
      NON_PLU_TYPE_CD: 'I04W0P6C1',
    },
    TBBA003: {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      SHOP_ID: '0003809',
      TNANT_NM: 'ShinSeGaeI&C',
      TNANT_SHORT_NM: 'ShinSeGaeI&C',
      TNANT_EN_NM: '',
      TNANT_EN_SHORT_NM: '',
      BZ_NO: '2018120549',
      STORE_OWN_NM: 'ShinSeGaeI&C',
      TEL_NO: '020000000',
      FAX_NO: '',
      EMAIL_ADDR: '',
      ZIPNO: '04529',
      BASE_ADDR: '서울특별시 중구 회현동1가 204 (MESA)',
      DTL_ADDR: '1501호',
      BASE_ADDR_EN: '',
      DTL_ADDR_EN: '',
      FLOOR_FLG_CD: '0001',
      CONT_AREA: 0,
      DVT_AREA: 0,
      TNANT_AREA: 0,
      OPEN_YN: 'Y',
      OPEN_DATE: '20230731',
      CLSP_YN: 'N',
      CLSP_DATE: '',
      BANK_CD: '',
      BANK_ACC_NO: '',
      DPSTOR_NM: '',
      PARKING_CD: '',
      STMP_PRT_FLG_CD: 'X',
      STMP_FILE_ID: '',
      STMP_FILE_URL: '',
      CI_PRT_YN: 'N',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-19 11:07:38',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-19 11:07:38',
      UPDTER_ID: '',
      UPDT_IP: '',
      STK_MV_USE_YN: 'N',
      STK_MV_BAS_FLG: '0',
      STK_MV_DIT_GRP: '',
      STK_MV_DIT_PRICE: 0,
      TNANT_TYPE: '01',
      APPR_FLG: '02',
      SALE_FLG: '01',
      CHANNEL_FLG: '01',
      MST_USE_YN: null,
      ERP_TNANT_CD: null,
      AREA: null,
      FOODTECH_CODE: null,
      SOHO_BRAND_FLG_CD: null,
      CLAS_LEVEL: null,
      NON_PLU_PREFIX: '20',
      NON_PLU_TYPE_CD: 'I04W0P6C1',
      DECIMAL_PLC: 0,
      AMT_UNIT: '1',
      SALE_UNIT: '2',
      AMT_CMPT_TYPE: '1',
      TAX_CMPT_TYPE: '1',
      DC_SALE_UNIT: '1',
      DC_COMP_TYPE: '',
      DC_TARGET_AMT_TYPE: '1',
      TAX_RATE: 10,
      TAX_RDC_RATE: 0,
      LANG_FLG: 'KO',
      DC_CMPT_TYPE: '1',
      VAT_CMPT_TYPE: '',
    },
    TBBA008: {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      POS_NO: '0005',
      POS_NM: '123',
      POS_EN_NM: '',
      FRONT_SYS_FLG_CD: '01',
      POS_TMNL_FLG_CD: '8',
      TEL_NO: '',
      IP: '',
      FLOOR_FLG_CD: '0000',
      INSTALL_LOC: '',
      DEVICE_SERIAL_NO: '',
      USE_FROM_DATE: '20230816',
      USE_END_DATE: '29991231',
      DISTOR_MODEL_NO: '',
      DISTOR_USE_CNT: 0,
      USE_YN: 'Y',
      DEL_YN: 'N',
      REG_DTMS: '2023-10-19 11:07:39',
      REGER_ID: '',
      REG_IP: '',
      UPDT_DTMS: '2023-10-19 11:07:39',
      UPDTER_ID: '',
      UPDT_IP: '',
      SETUP_STATUS_CD: '2',
      ETC_TYPE_CD: '',
    },
    TB_MST_TNANT_PRINTOUT: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '01',
        PRINTOUT_FORM:
          '{로고이미지}\n\n{NADD}{FONT4}{CENTER}[주문 번호 : {교환권번호}]\n\n{NADD}{상단메시지}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{LINE_-}\n{상품리스트1}\n{LINE_-}\n{과세내역1}\n{LINE_-}\n{합계내역1}\n{결제내역1}\n{LINE_-}\n{스마트오더_완료영수증}\n{배달정보1}\n{CENTER}{캐셔정보1}\n\n{바코드1}\n\n{NADD}{하단메시지}\n{NADD}{무료주차안내}\n\n교환 및 환불은 영수증과 원거래          \n결제 수단 지참 후 14일 이내에           \n가능합니다. 단, 환불은 구입하신         \n매장에서만 가능합니다.  \n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '02',
        PRINTOUT_FORM:
          '{CENTER}{로고이미지}\n{CENTER}{FONT4}주문내역서\n{LINE_-}\n{FONT4}{CENTER}[주문번호 : {주문번호}]\n{LINE_-}\n[주문시간 : {판매일자} {판매시간}]\n{LINE_-}\n{상품리스트2-5}\n{LINE_-}\n{FONT3}{합계내역1}\n{LINE_-}\n판매자:{캐셔번호}({캐셔명})\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '03',
        PRINTOUT_FORM:
          '{CENTER}{FONT4}{타이틀1}\n{LINE_-}\n{CENTER}{FONT4}[주문번호 : {주문번호}]\n{LINE_-}\n{FONT3}{주방상품리스트1}\n{LINE_-}\n{FONT1}[주문시간 : {현재시간}]\n\n{CUT}\n',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '04',
        PRINTOUT_FORM: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '05',
        PRINTOUT_FORM:
          '{CENTER}{FONT4}교환권\n{LINE_-}\n{FONT4}{CENTER}[주문 번호 : {교환권번호}]\n{LINE_-}\n{FONT3}{교환권상품리스트1}\n{FONT1}\n{LINE_-}\n[주문시간 : {현재시간}]\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '06',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 준비금 ]\n{준비금}\n{NADD}{CENTER}{재발행2}\n{CENTER}{캐셔정보1}\n\n{바코드2}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '07',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 시재출금 ]\n{시재출금}\n{NADD}{CENTER}{재발행2}\n{CENTER}{캐셔정보1}\n\n{바코드2}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '08',
        PRINTOUT_FORM:
          '{NADD}{상단메시지}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n            == 정산 영수증 ==\n          영업일자 : {판매일자}\n{정산_항목명}\n{정산_매출합계}\n{정산_결제수단별}\n{정산_현금}\n{정산_신용_현금IC}\n{정산_계약금}\n{정산_배달}\n{정산_고객수}\n\n{캐셔정보1}\n\n{바코드1}\n\n{NADD}{하단메시지}\n{NADD}{무료주차안내}\n\n교환 및 환불은 영수증과 원거래          \n결제 수단 지참 후 14일 이내에           \n가능합니다. 단, 환불은 구입하신         \n매장에서만 가능합니다.  \n\n{로고이미지}\n\n{CUT}  ',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '09',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}[{SMT채널사명}]주문{취소구분} 전표[고객용]\n{FONT3}{CENTER}[{발행구분}]\n{SMT주문구분}\n{FONT3}{CENTER}▶ {SMT결제구분} ◀\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_=}\n{FONT3}{SMT주소정보1}\n{FONT3}[연락처] : {SMT전화번호}\n{FONT3}{SMT요청사항1}\n{LINE_=}\n{FONT1}{상품리스트1-2}\n{LINE_-}\n{FONT1}{SMT합계내역1}\n{LINE_-}\n{FONT1}{SMT결제내역1}\n{LINE_-}\n▶상세 내역은 배달앱에서 확인하세요.◀\n[원산지] \n배달주문상품->쌀[국내산],돼지고기[외국산\n(미국,스페인,캐나다 등), 국내산혼합],돼\n지고기[미국산,국내산],달고기[미국산],소\n고기[호주산],배추김치(배추,고추가루)[중\n국산],배추김치(배추)[중국산],배추김치(고\n춧가루)[중국산]\n{LINE_=}\n[매장명]{매장명}\n[발행일시]{현재시간}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '10',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}{취소구분}주방주문서[{발행구분}]\n{SMT주문구분}\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_=}\n{FONT3}{주방상품리스트5}\n{LINE_-}\n{FONT3}{SMT요청사항2}\n{LINE_-}\n{LINE_=}\n[POS]{POS번호} \n[발행일시]{현재시간}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '11',
        PRINTOUT_FORM:
          '{CENTER}{FONT3}{MINUSSHADOW}[스마트오더]\n[주문채널] : {SMT채널사명}-{SMT채널주문번호}\n{SMT접수번호1}\n[POS] : {POS번호}-{주문번호} [{SMT제공사명}] : {SMT제공주문번호}\n[{SMT주문구분} 예정시간] : {SMT예정시간}분\n[주문일시] : {SMT주문일시}\n{SHADOW}{SMT예약일시1}\n{LINE_-}\n{FONT3}{SMT요청사항1}\n{LINE_-}\n{FONT1}{SMT결제내역1}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        PRINTOUT_FLG_CD: '12',
        PRINTOUT_FORM:
          '{NADD}{CENTER}{재발행1}\n\n점  포  명:{매장명}\n대  표  자:{매장대표자명}\n사업자번호:{매장사업자번호}\n전 화 번호:{매장전화번호}\n{주소1}\n{주소2}\n\n{판매일자} {판매시간}\n거래번호:{POS번호}-{거래번호}\n{FONT2}{CENTER}[ 개점 ]\n{CENTER}{캐셔정보1}\n\n{바코드1}\n\n{CUT}',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:39',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:39',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    TB_MST_SLDOUT: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000135',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000136',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000137',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000138',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000139',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000140',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000141',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000142',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000143',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000144',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000145',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000146',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000151',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        ITEM_CD: '00000154',
        SLDOUT_YN: 'N',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:42',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:42',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    TB_MST_KIOSK_CLAS: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        KOS_CLASS_CD: '기본',
        KOS_ORDER: 1,
        KOS_MENU_NM_KO: '커피',
        KOS_MENU_NM_EN: 'Coffee',
        KOS_MENU_NM_JP: 'コーヒー',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:43',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:43',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '커피',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        KOS_CLASS_CD: '에이드/주스',
        KOS_ORDER: 2,
        KOS_MENU_NM_KO: '에이드/주스',
        KOS_MENU_NM_EN: 'Ade/Juice',
        KOS_MENU_NM_JP: 'エイド/カジュース',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:43',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:43',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '에이드/주스',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        KOS_CLASS_CD: '베버리지',
        KOS_ORDER: 3,
        KOS_MENU_NM_KO: '음료',
        KOS_MENU_NM_EN: 'Beverage',
        KOS_MENU_NM_JP: '飲料',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:43',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:43',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '베버리지',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        KOS_CLASS_CD: '차',
        KOS_ORDER: 4,
        KOS_MENU_NM_KO: '차',
        KOS_MENU_NM_EN: 'Tea',
        KOS_MENU_NM_JP: '茶',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:43',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:43',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '차',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        KOS_CLASS_CD: '푸드',
        KOS_ORDER: 5,
        KOS_MENU_NM_KO: '푸드',
        KOS_MENU_NM_EN: 'Food',
        KOS_MENU_NM_JP: 'フード',
        KOS_MENU_NM_CN: '',
        KOS_MENU_NM_TW: '',
        KOS_USE_YN: 'Y',
        SMARTORDER_YN: 'N',
        KOS_MENU_IMG_FILE_ID: '',
        KOS_MENU_IMG_FILE_URL: '',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:07:43',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:07:43',
        UPDTER_ID: '',
        UPDT_IP: '',
        KOS_MENU_NM: '푸드',
      },
    ],
    TB_MST_TNANT_BIZTIME: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '1',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '2',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '3',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '4',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '5',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '6',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        DAY: '7',
        OPEN_TIME: '0000',
        CLOSE_TIME: '2359',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:26',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:26',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
    POS_DEVICE_INFO: [
      {
        SHOP_ID: '0003809',
        POS_NO: '0005',
        DEVICE_CODE: 'DEV01',
        SEQ: 0,
        CONNECT_TYPE: '02',
        PORT: '1',
        BAUDRATE: '9600',
        IP_ADDRESS: '',
        DEVICE_NAME: '영수증프린터',
        MODEL_CODE: 'SerialPrinter',
        PRINT_CNT: '',
        PRINT_FLAG: '',
        DEL_YN: 'N',
      },
    ],
    TB_MST_CUST_DISP: [
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '04',
        SEQ_NO: 1,
        DISP_KIND_CD: 'T',
        DISP_TEXT_KO: '안녕하세요^주문 방법을^선택해주세요.',
        DISP_TEXT_EN: 'Welcome^Touch To Start',
        DISP_TEXT_JP: 'いらっしゃいませ^ご注文を選択してください。',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '',
        FILE_URL: '',
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'Y',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '05',
        SEQ_NO: 1,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '',
        DISP_TEXT_EN: '',
        DISP_TEXT_JP: '',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375274',
        FILE_URL: require('../../../assets/images/beverage/banner/KIOSK_CAFFEE_Baner.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 5,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '',
        FONT_SIZE_CD: '',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 1,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '얼그레이티',
        DISP_TEXT_EN: 'Earl Gray Tea',
        DISP_TEXT_JP: 'アールグレイティー',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375268',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO01_img_EarlGrayTea.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 1,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 2,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '레드베리에이드',
        DISP_TEXT_EN: 'Red Berry Ade',
        DISP_TEXT_JP: 'レッドベリーエイド',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375269',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO02_img_RedBerryAde.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 2,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 3,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '카페라떼',
        DISP_TEXT_EN: 'Cafe Latte',
        DISP_TEXT_JP: 'カフェラテ',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375270',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO03_img_CafeLatte.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 3,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 4,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '말차 스무디',
        DISP_TEXT_EN: 'Matcha Smoothie',
        DISP_TEXT_JP: '抹茶スムージー',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375271',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO04_img_MatchaSmoothie.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 4,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 5,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '딸기 스무디',
        DISP_TEXT_EN: 'Strawberry Smoothie',
        DISP_TEXT_JP: 'ストロベリースムージー',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375270',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO05_img_StrawberrySmoothie.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 5,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
      {
        CP_CD: '0801',
        STORE_CD: '0001',
        TNANT_CD: '0009',
        SHOP_ID: '0003809',
        GRP_CD: '000001',
        DISP_AREA: '06',
        SEQ_NO: 6,
        DISP_KIND_CD: 'I',
        DISP_TEXT_KO: '오레오 밀크 스무디',
        DISP_TEXT_EN: 'Oreo Milk Smoothie',
        DISP_TEXT_JP: 'オレオミルクスムージー',
        DISP_TEXT_CN: '',
        DISP_TEXT_TW: '',
        FILE_ID: '2122375271',
        FILE_URL: require('../../../assets/images/beverage/idle/INTRO06_img_OreoMilkSmoothie.png'),
        MOV_TN_FILE_ID: '',
        MOV_TN_FILE_URL: '',
        DISP_TIME: 60,
        FROM_DATE: '20230801',
        END_DATE: '99990831',
        FROM_TIME: '0000',
        END_TIME: '2359',
        DISP_ORDER: 6,
        FONT_FLG_CD: '1',
        FONT_SIZE_CD: '10',
        BOLD_YN: 'N',
        USE_YN: 'Y',
        DEL_YN: 'N',
        REG_DTMS: '2023-10-19 11:08:33',
        REGER_ID: '',
        REG_IP: '',
        UPDT_DTMS: '2023-10-19 11:08:33',
        UPDTER_ID: '',
        UPDT_IP: '',
      },
    ],
  },
  message: '',
};
